module.exports = __webpack_public_path__ + "static/product2-c7b424d2dab55c1bc8843106adc8b96e.svg";